import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/app");
    } catch (e2) {
      const msg = e2?.response?.data?.detail || "Invalid credentials";
      setErr(typeof msg === "string" ? msg : "Invalid credentials");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="mx-auto max-w-6xl px-6 h-16 flex items-center justify-between">
          <Logo />
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900">← Back to home</Link>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="bg-white border border-slate-200 rounded-lg p-8 warm-shadow">
            <h1 className="text-2xl font-bold text-slate-900">Sign in</h1>
            <p className="mt-1 text-sm text-slate-600">Enter your email and password to access your account.</p>

            <form onSubmit={onSubmit} className="mt-6 space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="login-email-input" className="mt-1.5" placeholder="you@company.com" />
              </div>
              <div>
                <div className="flex items-center justify-between">
                  <Label htmlFor="password">Password</Label>
                  <a href="#" className="text-xs text-blue-600 hover:text-blue-700">Forgot?</a>
                </div>
                <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="login-password-input" className="mt-1.5" />
              </div>
              {err && <div className="text-sm text-red-600" data-testid="login-error">{err}</div>}
              <Button type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-700" data-testid="login-submit-btn">
                {busy ? "Signing in…" : "Sign in"}
              </Button>
            </form>
          </div>

          <p className="mt-6 text-center text-sm text-slate-600">
            Don't have an account?{" "}
            <Link to="/register" className="text-blue-600 hover:text-blue-700 font-medium" data-testid="login-register-link">
              Create one →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
